import {
  TOrderEntryPayload,
  TOrderEntryResult,
} from '../../../shipmetrics-shared/containers/OrderEntry/types'
import { request } from '../../../1stlog-ui/src/utils'
import { AxiosResponse } from 'axios'

export async function requestSubmit(payload: TOrderEntryPayload): Promise<TOrderEntryResult> {
  const { data } = (await request({
    method: 'post',
    url: '/api/order/submit',
    data: payload,
  })) as AxiosResponse<any>
  // FIXME: backend error: order is created, but clientNotifications cause crash in StoreOrderService:418
  return data
}
